import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import { breakpoints } from '../config/breakpoints';

export default function () {
  const buttons = window.document.querySelectorAll('.wpcf7-submit');
  const inputs = window.document.querySelectorAll('.form__input');
  const dates = window.document.querySelectorAll('.form__input--date');
  const selects = window.document.querySelectorAll('.form__input--select');
  const numberInputs = window.document.querySelectorAll('.form__input--number');
  const selectorControl = '.form__control';
  const selectorLabel = '.form__label';
  const classFocus = 'focus';
  const classOpen = 'open';
  const classHover = 'hover';
  const classError = 'error';

  function labelFocusIn(input) {
    const control = input.closest(selectorControl);
    const label = control.querySelector(selectorLabel);

    if (label) {
      label.classList.add(classFocus);
    }
  }

  function labelFocusOut(input) {
    const control = input.closest(selectorControl);
    const label = control.querySelector(selectorLabel);
    window.setTimeout(() => {
      if (input.value.trim().length !== 0) {
        return false;
      }
      if (label) {
        label.classList.remove(classFocus);
      }
      return false;
    });
  }

  function labelsFocusIn(inputsAll) {
    inputsAll.forEach((input) => {
      if (input.value.trim().length !== 0) {
        labelFocusIn(input);
      }
    });
  }

  function labelMouseOver(input) {
    const control = input.closest(selectorControl);
    const label = control.querySelector(selectorLabel);

    if (label) {
      label.classList.add(classHover);
    }
  }

  function labelMouseOut(input) {
    const control = input.closest(selectorControl);
    const label = control.querySelector(selectorLabel);

    if (label) {
      label.classList.remove(classHover);
    }
  }

  function controlFocusIn(input) {
    const control = input.closest(selectorControl);
    control.classList.add(classFocus);
  }

  function controlFocusOut(input) {
    const control = input.closest(selectorControl);
    control.classList.remove(classFocus);
  }

  function arrowToggle(input) {
    const control = input.closest(selectorControl);
    control.classList.toggle(classOpen);
  }

  function arrowOpen(input) {
    const control = input.closest(selectorControl);
    control.classList.add(classOpen);
  }

  function arrowClose(input) {
    const control = input.closest(selectorControl);
    control.classList.remove(classOpen);
  }

  function errorAdd(input) {
    const control = input.closest(selectorControl);
    control?.classList.add(classError);
    control?.querySelector(selectorLabel)?.classList.add(classError);
  }

  function errorRemove(input) {
    const control = input.closest(selectorControl);
    control?.classList.remove(classError);
    control?.querySelector(selectorLabel)?.classList.remove(classError);
  }

  // eslint-disable-next-line consistent-return
  function validateNumberInput(event) {
    const allowedKeys = ['Backspace', 'Tab', 'Escape', 'Shift', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];

    if (allowedKeys.includes(event.key)) {
      return false;
    }

    const regex = /^[0-9]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  function mobileCompatible(button) {
    const buttonClasslist = button.classList;

    if (buttonClasslist.contains('c-button--fill')) {
      buttonClasslist.remove('c-button--fill');
      buttonClasslist.add('c-button--form-fill');
    }

    if (buttonClasslist.contains('c-button--transparent') && buttonClasslist.contains('c-button--theme--dark')) {
      buttonClasslist.remove('c-button--transparent');
      buttonClasslist.remove('c-button--theme--dark');
      buttonClasslist.add('c-button--form-transparent--dark');
    }
  }

  function isMobileByPixels() {
    if (document.documentElement.clientWidth < breakpoints.lg) {
      return true;
    }

    if (window.innerWidth < breakpoints.lg) {
      return true;
    }

    return false;
  }

  function operateWithSubmitButtons() {
    const submitButtons = document.querySelectorAll('input.wpcf7-submit');

    if (submitButtons) {
      submitButtons.forEach((submitButton) => {
        // eslint-disable-next-line no-param-reassign
        submitButton.tabIndex = 0;

        if (isMobileByPixels()) {
          mobileCompatible(submitButton);
        }
      });
    }
  }

  function rfpFormPopulateAppointmentType() {
    const queryString = window.location.search;
    const queryStringParams = new URLSearchParams(queryString);
    const appointmentTypeParam = queryStringParams.get('appttype');
    const appointmentTypeElem = window.document.getElementById('appttype');
    if (appointmentTypeElem) {
      [...appointmentTypeElem.options].map((option) => {
        if (option.value === appointmentTypeParam) {
          option.setAttribute('selected', true);
        }
        return true;
      });
    }
  }

  function scrollToSignupForm() {
    const queryStringParams = new URLSearchParams(window.location.search);
    if (!queryStringParams.has('rid')) {
      return;
    }

    // The server prefills the email only when rid matches a signup, so an
    // empty field means there is nothing to scroll to.
    const emailInput = window.document.querySelector('[name="newsletter_email"]');
    const form = emailInput?.closest('.wpcf7');
    if (!form || emailInput.value === '') {
      return;
    }

    // Don't move the page if the user has already scrolled or started typing.
    const { activeElement } = window.document;
    if (window.scrollY > 0 || activeElement?.matches('input, textarea, select')) {
      return;
    }

    // Instant jump: a smooth scroll would trigger lazyload and c-appeared
    // for every block it passes.
    form.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Intel Mac OS X/i.test(navigator.userAgent);
  }

  window.addEventListener('load', () => {
    labelsFocusIn(inputs);
    scrollToSignupForm();
  });

  inputs.forEach((input) => {
    input.addEventListener('focusout', () => {
      controlFocusOut(input);
      window.setTimeout(() => {
        labelFocusOut(input);
      }, 200);
      if (!input.classList.contains('wpcf7-not-valid')) {
        errorRemove(input);
      } else {
        errorAdd(input);
      }
    });
    input.addEventListener('focus', () => {
      labelFocusIn(input);
      controlFocusIn(input);
    });
    input.addEventListener('mouseover', () => {
      labelMouseOver(input);
    });
    input.addEventListener('mouseout', () => {
      labelMouseOut(input);
    });
    input.addEventListener('input', (event) => {
      // eslint-disable-next-line no-param-reassign
      event.target.value = event.target.value.trimStart();
    });
  });

  dates.forEach((item) => {
    // eslint-disable-next-line no-unused-vars
    const picker = new AirDatepicker(item, {
      locale: localeEn,
      dateFormat: 'MM/dd/yyyy',
      autoClose: true,
      toggleSelected: false,
      minDate: Date.now(),
      onSelect: () => {
        // eslint-disable-next-line no-undef
        wpcf7.validate(item.closest('form'), { target: item });

        if (item.nextSibling && item.nextSibling.classList.contains('wpcf7-not-valid-tip')) {
          errorRemove(item);
        }
      },
    });
    item.addEventListener('keydown', (event) => {
      const code = (event.keyCode ? event.keyCode : event.which);
      if (code === 13) {
        event.preventDefault();
      }
    });
    item.addEventListener('focusout', () => {
      arrowClose(item);
    });
    item.addEventListener('focusin', () => {
      arrowOpen(item);
    });
    picker.$datepicker.addEventListener('mousedown', (event) => {
      event.preventDefault();
    });
  });

  function usesSafariEngine() {
    const ua = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(ua)) {
      return true;
    }

    if (/Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium/.test(ua)) {
      return true;
    }

    return false;
  }

  selects.forEach((item) => {
    if (!usesSafariEngine()) {
      item.addEventListener('click', () => {
        arrowToggle(item);
      });
    }

    item.addEventListener('focusout', () => {
      arrowClose(item);
    });

    item.addEventListener('change', () => {
      if (isMobile()) {
        arrowClose(item);
      }
    });

    if (item.closest('.wpcf7')) {
      // eslint-disable-next-line no-param-reassign
      item.selectedIndex = -1;
    }
  });

  numberInputs.forEach((item) => {
    item.addEventListener('keydown', validateNumberInput);
  });

  window.document.addEventListener('wpcf7invalid', () => {
    window.setTimeout(() => {
      const errorInputs = window.document.querySelectorAll('.wpcf7-not-valid');
      errorInputs.forEach((input) => {
        errorAdd(input);
      });
    });
  });

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const form = event.target.closest('form');
      const errors = form.querySelectorAll('.error');
      errors.forEach((error) => {
        error.classList.remove('error');
      });
    });
  });

  document.querySelectorAll('form').forEach((formElement) => {
    formElement.addEventListener('submit', () => {
      if (isMobileByPixels()) {
        const filledButton = formElement.querySelector('.c-button--form-fill');
        const transparentButton = formElement.querySelector('.c-button--form-transparent--dark');

        if (filledButton) {
          filledButton.classList.remove('c-button--form-fill');
          filledButton.classList.add('c-button--form-transparent');
        }

        if (transparentButton) {
          transparentButton.classList.remove('c-button--form-transparent--dark');
          transparentButton.classList.add('c-button--form-fill--dark');
        }
      }
    });
  });

  window.document.addEventListener('wpcf7mailsent', (event) => {
    window.setTimeout(() => {
      const inputsNames = event.detail.inputs.map((inputObj) => inputObj.name);
      inputsNames.forEach((inputName) => {
        const inputElement = document.querySelector(`[name="${inputName}"]`);
        if (inputElement) {
          if (inputElement.classList.contains('form__input--select')) {
            inputElement.value = '';
          }

          labelFocusOut(inputElement);
          controlFocusOut(inputElement);
          errorRemove(inputElement);
        }
      });
    });
  });

  window.document.addEventListener('wpcf7submit', (event) => {
    if (isMobileByPixels()) {
      const buttonTransparent = event.target.querySelector('.c-button--form-transparent');
      const buttonFilled = event.target.querySelector('.c-button--form-fill--dark');

      if (buttonTransparent) {
        buttonTransparent.classList.remove('c-button--form-transparent');
        buttonTransparent.classList.add('c-button--form-fill');
      }

      if (buttonFilled) {
        buttonFilled.classList.remove('c-button--form-fill--dark');
        buttonFilled.classList.add('c-button--form-transparent--dark');
      }
    }
  });

  window.document.addEventListener('DOMContentLoaded', () => {
    const checkboxes = document.querySelectorAll('.wpcf7-form-control.wpcf7-checkbox');

    operateWithSubmitButtons();

    rfpFormPopulateAppointmentType();

    if (checkboxes) {
      checkboxes.forEach((item) => {
        const label = item.querySelector('label');
        label.tabIndex = 0;

        label.addEventListener('keyup', (event) => {
          if (event.keyCode === 13 || event.keyCode === 32) {
            event.preventDefault();
            label.click();
          }
        });
      });
    }

    const gallerySelect = document.getElementById('gallery-select-sr');
    if (gallerySelect) {
      gallerySelect.addEventListener('change', (event) => {
        event.target.closest('form').submit();
      });
    }
  });

  window.document.addEventListener('resize', () => {
    operateWithSubmitButtons();
  });
}
